module.exports = __webpack_public_path__ + "img/pessoa-vermelho.3cff926e.svg";